namespace GeniuzPOS.InitialData {
    export enum DiscCouponValueType {
        DiscValueType = 0,
        DiscValueType1 = 1,
        DiscValueType2 = 2,
        DiscValueType3 = 3
    }
    Serenity.Decorators.registerEnumType(DiscCouponValueType, 'GeniuzPOS.InitialData.DiscCouponValueType');
}
